import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  item: [],
  contactDetails: {},
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    increment: (state: any, action) => {
      // state.value += 1;
      state.item = [...state.item, action.payload];
    },
    decrement: (state, action) => {
      // state.value -= 1;
    },
    contactDetails: (state, action) => {
      state.contactDetails = action.payload;
    },
  },
});

export const { increment, decrement, contactDetails } = cartSlice.actions;
export default cartSlice.reducer;
